import type { OddsQuote } from '../../domain/types'
import { americanToDecimal } from '../../lib/math/odds'
import { todayIso } from '../synthetic'
import type { OddsAdapter } from './types'

function ml(
  id: string,
  event: string,
  sport: string,
  selection: string,
  american: number,
  modelProb: number,
  closingDecimal: number,
  group: string,
): OddsQuote {
  return {
    id,
    event,
    sport,
    marketType: 'moneyline',
    selection,
    format: 'american',
    decimalOdds: americanToDecimal(american),
    americanOdds: american,
    book: 'MockBook (legal demo)',
    timestamp: todayIso(),
    closingDecimal,
    modelProb,
    correlationGroup: group,
    legal: true,
  }
}

function buildOdds(): OddsQuote[] {
  return [
    ml('odds-bos-ml', 'Boston vs Denver', 'NBA', 'Boston', -120, 0.57, 1.8, 'nba-bos-den'),
    ml('odds-den-ml', 'Boston vs Denver', 'NBA', 'Denver', 110, 0.46, 2.1, 'nba-bos-den'),
    ml('odds-utd-ml', 'United vs City', 'EPL', 'United', 240, 0.34, 3.2, 'epl-utd-city'),
    ml('odds-city-ml', 'United vs City', 'EPL', 'City', -160, 0.63, 1.6, 'epl-utd-city'),
    ml('odds-yanks-ml', 'Yankees vs Rays', 'MLB', 'Yankees', -135, 0.6, 1.72, 'mlb-nyy-tb'),
  ]
}

export function createMockOddsAdapter(): OddsAdapter {
  return {
    id: 'mock-odds',
    name: 'Mock Sportsbook Odds (legal demo)',
    requiresApiKey: false,
    description: 'Synthetic moneyline odds for legal-market research demos. Not affiliated with any sportsbook.',
    async fetchOdds(): Promise<OddsQuote[]> {
      return buildOdds()
    },
  }
}

export { buildOdds as buildSampleOdds }
